<template>
    <span class="label label-dot" :class="[`label-${type}`]" :title="title"/>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'default'
        },
        title: String
    }
}
</script>
